<script>
import Main from '@/mixins/main';
import {Dialog, Toast} from 'vant';
import {QrcodeStream} from 'vue-qrcode-reader';

export default {
  mixins: [
    Main
  ],
  components: {
    QrcodeStream
  },
  data() {
    return {
      loading: false,
      destroyed: false
    };
  },
  watch: {
    $route(to) {
      if (to.name === 'scanQr') {
        this.reload();
      } else {
        this.destroyed = true;
      }
    }
  },
  mounted() {
    window.document.title = '速电通-扫码充电';

    this.requestFullscreen();
  },
  methods: {
    async onInit(promise) {
      this.loading = true;

      try {
        await promise
      } catch (error) {
        let errorMessage;
        if (error.name === 'NotAllowedError') {
          errorMessage = '需要授权访问摄像头';
        } else if (error.name === 'NotFoundError') {
          errorMessage = '没有发现摄像头';
        } else if (error.name === 'NotSupportedError') {
          errorMessage = '需要以https访问网页';
        } else if (error.name === 'NotReadableError') {
          errorMessage = '摄像头占用中';
        } else if (error.name === 'OverconstrainedError') {
          errorMessage = '摄像头不合适';
        } else if (error.name === 'StreamApiNotSupportedError') {
          errorMessage = '浏览器不支持';
        }

        if (errorMessage) {
          Toast.fail(errorMessage);
        }
      } finally {
        this.loading = false;
      }
    },
    async reload() {
      if (this.destroyed) {
        return;
      }

      this.destroyed = true;

      await this.$nextTick();

      this.destroyed = false;
    },
    track(location, ctx) {

      const {
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      } = location;

      const pointArray = [
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      ];

      ctx.fillStyle = '#009251';

      pointArray.forEach(({x, y}) => {
        ctx.fillRect(x - 5, y - 5, 10, 10);
      });
    },
    onDecode(result) {
      if (result.startsWith('coupon://')) {
        Dialog.confirm({
          title: '提示',
          message: '是否核销兑换券：' + result.replace(/[^0-9]/ig, '')
        }).then(() => {
          this.scanRequest(result);
        }).catch(() => {
          setTimeout(this.reload, 10000);
        });
      } else {
        this.scanRequest(result);
      }
    },
    requestFullscreen() {
      const elem = this.$refs.wrapper;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
  }
}
</script>

<template>
  <div class="fullscreen" ref="wrapper">
    <qrcode-stream v-if="!destroyed" :track="track" @decode="onDecode" @init="onInit">
      <div class="loading-indicator" v-if="loading">
        Loading...
      </div>
    </qrcode-stream>
  </div>
</template>

<style scoped>
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.loading-indicator {
  font-size: 16px;
  margin-top: 16px;
  text-align: center;
}
</style>